export const getUrlFromWindow = (): string => {
  if (typeof window === "undefined") return ""
  return window.location.href
}
